import React from 'react'
import { ArrowCircleRightOutlined } from '@mui/icons-material'
import { Box } from '@mui/material'
import FormDetailsStack from 'common/Form/FormDetailsStack'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'

export default function OrderDetail(props: IOrderDetail) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        '& .MuiTypography-root': { margin: 0 }
      }}
    >
      <TextColorFontHeader>Details</TextColorFontHeader>
      <Box>
        <FormDetailsStack
          formLabelHeader='Selected Order:'
          formContent={props.orderNo}
        />
      </Box>
      <Box>
        <FormDetailsStack
          formLabelHeader='Customer:'
          formContent={`${props.userName} (${props.userEmail})`}
        />
      </Box>
      <Box>
        <FormDetailsStack
          formLabelHeader='Total Cost:'
          formContent={`$${props.price}`}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          color: '#0000FF',
          cursor: 'pointer'
        }}
      >
        View Order Breakdown
        {/* TO REPLACE WITH THE CORRECT ICON */}
        <ArrowCircleRightOutlined />
      </Box>
    </Box>
  )
}

interface IOrderDetail {
  orderNo: string
  userName: string
  userEmail: string
  price: number
}
